import React from "react";

export default function StepThreeReview({
  addressName,
  fullAddress,
  addressTypes,
  selectedTypeId,
  fields,
  fieldValues,
  note,
  questions,
  answers,
  onBack,
  onDone,
}) {
  const selectedType = addressTypes.find((t) => t.id === selectedTypeId);

  const renderAnswerValue = (q) => {
    const ans = answers[q.id];
    if (!ans) return "-";

    if (q.type === "single_choice") {
      const opt = q.options?.find((o) => o.id === ans.question_option_id);
      if (!opt) return "-";
      const extra = ans.extra_texts?.[opt.id];
      return extra ? `${opt.label} (${extra})` : opt.label;
    }

    if (q.type === "multiple_choice") {
      const ids = ans.question_option_ids || [];
      if (!ids.length) return "-";
      const labels = ids.map((id) => {
        const opt = q.options?.find((o) => o.id === id);
        if (!opt) return null;
        const extra = ans.extra_texts?.[id];
        return extra ? `${opt.label} (${extra})` : opt.label;
      });
      return labels.filter(Boolean).join("، ") || "-";
    }

    if (q.type === "time") {
      const from = ans.answer_value?.from;
      const to = ans.answer_value?.to;
      if (!from && !to) return "-";
      return `${from || "--"} - ${to || "--"}`;
    }

    return ans.answer_value || "-";
  };

  const getSelectedOptionIds = (q) => {
    const ans = answers[q.id];
    if (!ans) return [];
    if (Array.isArray(ans.question_option_ids)) return ans.question_option_ids;
    if (ans.question_option_id != null) return [ans.question_option_id];
    return [];
  };

  const renderQuestionAndChildren = (q) => {
    const selectedIds = getSelectedOptionIds(q);

    const childQuestions = [];
    (q.options || []).forEach((opt) => {
      if (!selectedIds.includes(opt.id)) return;
      (opt.conditions || []).forEach((cond) => {
        if (cond.action === "show" && cond.target_question) {
          childQuestions.push(cond.target_question);
        }
      });
    });

    return (
      <React.Fragment key={q.id}>
        <div className="wizard-review-row">
          <span className="fw-medium">{renderAnswerValue(q)}</span>
          <span className="text-muted">{q.title}</span>
        </div>

        {childQuestions.length > 0 && (
          <div className="nested-question" style={{ borderBottom: "1px solid #f1f3f5" }}>
            {childQuestions.map((childQ) => renderQuestionAndChildren(childQ))}
          </div>
        )}
      </React.Fragment>
    );
  };

  return (
    <div className="row">
      <div className="col-lg-8">
        <div className="wizard-card p-4 mb-3">
          <p className="fw-semibold fs-5 mb-3">
            <i className="fa-solid fa-circle-check text-success me-2"></i>
            مراجعة البيانات
          </p>

          <div className="wizard-review-row">
            <span className="fw-medium">{addressName || "-"}</span>

            <span className="text-muted">اسم العنوان</span>
          </div>
          <div className="wizard-review-row">
            <span className="fw-medium">{fullAddress || "-"}</span>

            <span className="text-muted">العنوان</span>
          </div>
          <div className="wizard-review-row">
            <span className="fw-medium">{selectedType?.label || "-"}</span>

            <span className="text-muted">نوع المكان</span>
          </div>

          {fields.map((f) => (
            <div className="wizard-review-row" key={f.id}>
              <span className="fw-medium">
                {f.input_type === "select"
                  ? f.options.find(
                      (o) => String(o.id) === String(fieldValues[f.key]),
                    )?.label || "-"
                  : fieldValues[f.key] || "-"}
              </span>
              <span className="text-muted">{f.label}</span>
            </div>
          ))}

          <div className="wizard-review-row">
            <span className="fw-medium">{note || "-"}</span>

            <span className="text-muted">ملاحظات</span>
          </div>
        </div>

        <div className="wizard-card p-4">
          <p className="fw-semibold fs-6 mb-3">تفاصيل المكان</p>
          {questions.map((q) => renderQuestionAndChildren(q))}
        </div>
      </div>

      <div className="col-lg-4">
        <div className="wizard-card p-3">
          <p className="fw-semibold small mb-2">الخطوات</p>
          <div className="d-flex align-items-center gap-2 mb-2">
            <i className="fa-solid fa-circle-check text-success"></i>
            <span className="small text-muted">تحديد الموقع</span>
          </div>
          <div className="d-flex align-items-center gap-2 mb-2">
            <i className="fa-solid fa-circle-check text-success"></i>
            <span className="small text-muted">تفاصيل المكان</span>
          </div>
          <div className="d-flex align-items-center gap-2">
            <span className="wizard-mini-step active">3</span>
            <span className="small fw-medium">مراجعة وحفظ</span>
          </div>
        </div>
      </div>

      <div className="col-12 d-flex justify-content-between mt-4">
        <button className="btn wizard-btn-outline" onClick={onBack}>
          <i className="fa-solid fa-arrow-right me-1"></i> السابق
        </button>
        <button className="btn wizard-btn-dark" onClick={onDone}>
          تم <i className="fa-solid fa-check ms-1"></i>
        </button>
      </div>
    </div>
  );
}
